export const SIMULATION_CONFIG = {
  MAX_INITIAL_INVESTMENT: 100000000, // 初期投資額の最大値（1,000万円）
  MAX_MONTHLY_INVESTMENT: 100000, // 月額投資額の最大値（10万円）
} as const;

export const PERIOD_OPTIONS = Array.from({ length: 30 }, (_, i) => i + 1); 